import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

// This class ensures that reloading works correctly.
// Use this class to implement a proper caching strategy in the future
// to improve performance transitioning between routes by reusing components rather
// than destroying and rebuilding them.
export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        // Returning false here means that when we navigate to the same route,
        // it won't reuse the same component, but reload a new one.
        // This overrides the default strategy here: https://angular.dev/api/router/BaseRouteReuseStrategy?tab=description
        return false;
    }
}
